export default function SectionHeader({ children }) {
    return (
        <div className="tw-h-8">
            {children}
        </div>
    )
}